export const CURRENCIES = {
    // ── West Africa ──────────────────────────────────────────
    GHS: { code: 'GHS', decimals: 2, name: 'Ghanaian cedi', countries: ['GH'] },
    NGN: { code: 'NGN', decimals: 2, name: 'Nigerian naira', countries: ['NG'] },
    XOF: {
        code: 'XOF',
        decimals: 0,
        name: 'West African CFA franc',
        countries: ['SN', 'CI', 'ML', 'BF', 'BJ', 'TG', 'NE', 'GW'],
    },
    // ── East & Central Africa ────────────────────────────────
    RWF: { code: 'RWF', decimals: 0, name: 'Rwandan franc', countries: ['RW'] },
    BIF: { code: 'BIF', decimals: 0, name: 'Burundian franc', countries: ['BI'] },
    UGX: { code: 'UGX', decimals: 0, name: 'Ugandan shilling', countries: ['UG'] },
    KES: { code: 'KES', decimals: 2, name: 'Kenyan shilling', countries: ['KE'] },
    TZS: { code: 'TZS', decimals: 2, name: 'Tanzanian shilling', countries: ['TZ'] },
    XAF: {
        code: 'XAF',
        decimals: 0,
        name: 'Central African CFA franc',
        countries: ['CM', 'CF', 'TD', 'CG', 'GQ', 'GA'],
    },
    // ── Southern Africa ──────────────────────────────────────
    ZAR: { code: 'ZAR', decimals: 2, name: 'South African rand', countries: ['ZA'] },
    // ── Majors, for display and international cards ──────────
    USD: { code: 'USD', decimals: 2, name: 'US dollar', countries: ['US'] },
    EUR: { code: 'EUR', decimals: 2, name: 'Euro', countries: ['FR', 'BE', 'DE'] },
    GBP: { code: 'GBP', decimals: 2, name: 'Pound sterling', countries: ['GB'] },
};
export const CURRENCY_CODES = Object.keys(CURRENCIES);
export function isCurrencyCode(value) {
    return typeof value === 'string' && value in CURRENCIES;
}
/**
 * Minor-unit exponent for a currency. Unknown codes fall back to 2, which is
 * the common case — but an unknown code is a bug, so callers that can
 * validate should do so rather than relying on this.
 */
export function decimalsFor(currency) {
    return isCurrencyCode(currency) ? CURRENCIES[currency].decimals : 2;
}
/** How many minor units make one major unit: 100 for GHS, 1 for RWF. */
export function minorUnitsPerMajor(currency) {
    return 10 ** decimalsFor(currency);
}
/** The currency a country prices in, or null when we do not know. */
export function currencyForCountry(countryCode) {
    const upper = countryCode.toUpperCase();
    const match = CURRENCY_CODES.find((code) => CURRENCIES[code].countries.includes(upper));
    return match ?? null;
}
